<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Faculty Authority Linking</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center">
                <v-col sm="6" md="6">
                    <v-autocomplete :items="inst_list" item-value="id" v-model="inst" item-text="name"
                        label="Search Instructor" dense multiple rounded outlined
                        placeholder="Search by Emp code or Name" color="#0f2027"></v-autocomplete>
                </v-col>
                <v-btn class="button mt-4" :loading="loader" v-if="inst.length!=0" small
                    @click="fetchAuthority()">Fetch</v-btn>
            </v-row>
        </v-card>
        <v-card class="box" v-if="show == true">
            <v-col cols="12" sm="12" md="12">
                <v-simple-table id="" dense class="elevation-1 mytable" fixed-header height="500px">
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Name</th>
                            <th>Recommending</th>
                            <th>Approving</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(inst,index) in inst_data_list" :key="inst.id">
                            <td>{{index+1}}</td>
                            <td>{{inst.name}}</td>
                            <td style="width: 500px;">
                                <!-- <v-col class="m-0 p-0" cols="12" sm="8" md="8"> -->
                                <v-autocomplete :items="inst_list_auth_link" v-model="inst.recomonding_name"
                                    item-text="name" label="Search Instructor" dense rounded outlined return-object
                                    placeholder="Search by Emp code or Name" color="#0f2027"
                                    @change="saveAuthorityLinking(inst.recomonding_name,inst.id,inst.self_auth_r_id)"></v-autocomplete>
                                <!-- </v-col> -->
                            </td>
                            <td style="width: 500px;">
                                <!--<v-col class="m-0 p-0" cols="12" sm="8" md="8"> -->
                                <v-autocomplete :items="inst_list_auth_link" v-model="inst.approving_name"
                                    item-text="name" label="Search Instructor" dense rounded outlined return-object
                                    placeholder="Search by Emp code or Name" color="#0f2027"
                                    @change="saveAuthorityLinking(inst.approving_name,inst.id,inst.self_auth_id)"></v-autocomplete>
                                <!-- </v-col> -->
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data() {
            return {
                load: false,
                loading3: false,
                search: "",
                inst_list: [],
                inst: [],
                search: "",
                snackbar_msg: "",
                // extraBreadcrumbItems: [
                   

                // ],
                // breadcrumbClass: "breadcrumb-style1",
                color: "",
                snackbar: false,
                self_auth_type_list: [],
                inst_data_list: [],
                inst_list_auth_link: [],
                show: false,
                inst_id: null,
                loader: false,
            };
        },
        mounted() {
            this.onload();
        },
        methods: {
            saveAuthorityLinking(item, inst_id, self_auth_id) {
                console.log("item", item);
                console.log("inst_id", inst_id);
                console.log("self_auth_id", self_auth_id);
                const data = {
                    inst_id: inst_id,
                    authority_id: item.id,
                    self_auth_id: self_auth_id,
                };
                axios
                    .post("/SelfAppraisal/saveSelfApprisalAuthorityLinking", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Faculty authority linking done...");
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
            fetchAuthority() {
                this.loader = true;
                const data = {
                    inst_id: this.inst,
                };
                axios
                    .post("/SelfAppraisal/fetchAuthority", data)
                    .then((res) => {
                        this.self_auth_type_list = res.data.self_auth_type_list;
                        this.inst_data_list = res.data.inst_data_list;
                        this.inst_list_auth_link = res.data.inst_list;
                        this.show = true;
                        this.loader = false;
                    })
                    .catch((error) => {
                        window.console.log(error);
                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                        this.loader = false;
                    })
                    .finally(() => {
                        //close loader
                        // this.dataTable = $("#admitted-student-report").DataTable({
                        //     colReorder: true,
                        //     dom: "Bfrtip",
                        //     buttons: ["csvHtml5", "excelHtml5"],
                        // });
                        // this.dataTable = $("#admitted-student").DataTable({
                        //     colReorder: true,
                        //     dom: "Bfrtip",
                        //     buttons: ["csvHtml5", "excelHtml5"],
                        // });
                        this.show = true;
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/SelfAppraisal/getAllInstructor")
                    .then((res) => {
                        this.inst_list = res.data.inst_list;
                    })
                    .catch((error) => {
                        window.console.log(error);

                        this.showSnackbar("#b71c1c", "Something went wrong !!!");
                    })
                    .finally(() => {
                        //close loader
                    });
            },
        },
    };
</script>
<style scoped>
    .text-color {
        font-weight: bold;
        color: red;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
        }
        td + td,
        th + th {
            width: auto;
        }
    }
    table {
        white-space: nowrap !important;
        text-align: center;
    }
    .mytable /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .dt-button {
        font-size: 14px;
        font-weight: bold;
    }
    .dt-button.buttons-print::before {
        content: "\F42A";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    .dt-button.buttons-excel::before {
        content: "\F21B";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    .dt-button.buttons-csv::before {
        content: "\FEC2";
        margin-right: 8px;
        margin-top: 8px;
        font-size: 18px;
        font-family: "Material Design Icons";
    }
    button.dt-button:hover:not(.disabled),
    div.dt-button:hover:not(.disabled),
    a.dt-button:hover:not(.disabled) {
        border-color: #ff9800;
        color: #ff9800;
    }
    .dataTables_wrapper .dataTables_filter input[type="search"] {
        border-radius: 2px;
        border: 1px solid #cdcdcd;
        cursor: auto;
        white-space: nowrap !important;
    }
</style>
